import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../../layout/Footer/Footer";
import Navbar from "../../layout/Navbar/Navbar";
import Events from "../../sections/Events/Events";
import SlideIn from "../../ui/SlideIn/SlideIn.js";
import "./AboutStyles.scss";

function About() {
	const { t } = useTranslation();

	useEffect(() => {
		document.title = "About us | GLuck Esports";
	}, []);

	return (
		<section id="about" className="about-page">
			<Navbar isVisible={true} />
			<div className="about__container">
				<div className="about__text">
					<SlideIn direction="up" delay={80} threshold={0.1}>
						<p className="about__paragraph">{t("aboutPage.paragraph1")}</p>
						<p className="about__paragraph">{t("aboutPage.paragraph2")}</p>
						<p className="about__paragraph">{t("aboutPage.paragraph3")}</p>
					</SlideIn>
				</div>
			</div>
			<Events />
			<Footer alwaysVisible={true} />
		</section>
	);
}

export default About;
